import { globalAccessManagementEntryPoint } from '@jira/admin-pages__global-access-management/src/globalAccessManagementEntryPoint.entrypoint.tsx';
import { adminPagesGlobalAccessManagementRoute } from '@jira/router-routes__admin-pages-global-access-management-routes/src/adminPagesGlobalAccessManagementRoute.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router/src/common/types';
import { expValEquals } from '@atlassian/jira-feature-experiments';

const adminPagesGlobalAccessManagementPageEntryPoint = createPageEntryPoint({
	main: globalAccessManagementEntryPoint,
});

export const adminPagesGlobalAccessManagementRouteEntry: Route = createEntry(
	adminPagesGlobalAccessManagementRoute,
	() => ({
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		entryPoint() {
			return expValEquals('jira_global_access_management_page_exp', 'isEnabled', true, false)
				? adminPagesGlobalAccessManagementPageEntryPoint
				: notFoundPageEntrypoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName: '@jira/router-routes__admin-pages-global-access-management-entries',
				whichExportToUse: 'adminPagesGlobalAccessManagementRouteEntry',
			},
			enabled: true,
		},
	}),
);
